import { StyledAlert } from "App/global-style";
import { useTexts } from "Components/TextContext";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { isDefined } from "Utils/functions";
import React from "react";
import {
  DisabilityPension,
  WorkSituation,
} from "./ProductDetails/FormElements/interfaces";
import { useAdviceDetailsFormValues } from "./ProductPrice/hooks/stateSelectors";

export const DisabilityPensionInfo = (): React.ReactElement | null => {
  const isAdvisor = useIsAdvisorSelector();
  const { getText } = useTexts();
  const adviceDetails = useAdviceDetailsFormValues();

  if (!isDefined(adviceDetails)) {
    return null;
  }

  if (adviceDetails.workSituation === WorkSituation.WORK_PUBLIC) {
    return (
      <StyledAlert
        title={getText(
          isAdvisor
            ? "advicepage.disabilityflex.disabilitypensionpublicadvisor"
            : "advicepage.disabilityflex.disabilitypensionpublic",
        )}
      />
    );
  }

  switch (adviceDetails.disabilityPension) {
    case DisabilityPension.YES:
      return (
        <StyledAlert
          title={getText(
            isAdvisor
              ? "advicepage.disabilityflex.disabilitypensionyesadvisor"
              : "advicepage.disabilityflex.disabilitypensionyes",
          )}
        />
      );
    case DisabilityPension.DO_NOT_KNOW:
      return (
        <StyledAlert
          title={getText(
            "advicepage.disabilityflex.disabilitypensiondonotknow",
          )}
        />
      );
    default:
      return null;
  }
};
